(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskListAddFromTemplate',
	};

	var form_id = 'tasklistaddfromtemplate-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var $entity_field = null;
		var entity_type   = null;

		Adzuki.TaskManager.initTaskListForm(form_id);

		$entity_field = $('#' + form_id + 'entity_type');

		if ($entity_field.length > 0) {
			entity_type = $entity_field.val();

			// changes on the entity id
			$('#' + form_id + entity_type + '_id').on('change', function onEntityIdChange(e)
			{
				var entity_id = $(this).val();

				// use the name of the task list selected
				if (entity_type && entity_id) {
					Adzuki.Ajax.get('/TaskLists/getTaskListDetails/' + entity_type + '/' + entity_id)
						.then(function getTaskListDetails(response) {
							var current_name = $('#' + form_id + 'name').val();

							if (response.name && current_name === '') {
								$('#' + form_id + 'name').val(response.name);
							}
						});
				}

				// generate the due dates for the template tasks
				$('.task-template-id-field').each(function onEachTemplateHiddenField(i, $elem)
				{
					var $table_row       = $($elem).parents('.table-row');
					var task_template_id = $($elem).val();
					var due_based_on     = $table_row.data('task-template-due-date-based-on');
					var due_date_msg     = '';
					var uri              = null;

					$table_row.find('.task-template-due-date-warning')
						.first()
						.addClass('hidden');

					// this task template has a "no default due date"
					// don't add a default due date, and set the warning message
					if (due_based_on === 'no_due_date') {
						due_date_msg += '<strong>Please Note:</strong> this task was set up within the template to not<br>';
						due_date_msg += 'have a default date set. Therefore, you must manually<br>';
						due_date_msg += 'choose the due date in the date field above.';

						$table_row.find('.task-template-due-date-warning')
							.first()
							.html(due_date_msg)
							.removeClass('hidden');

						return true; // continue
					}

					// entity not provided, update due date with today's date
					if (!entity_id) {
						$table_row.find('.task-template-due-field')
							.first()
							.data('DateTimePicker')
							.date(moment().format('YYYY-MM-DD'));

						return true; // continue
					}

					if (task_template_id) {
						uri = '/TaskListTemplates/generateTaskTemplateDueDate/' + task_template_id + '/' + entity_id;

						// fill generated due dates for the tasks
						Adzuki.Ajax.get(uri).then(function populateEntityDates(response)
						{
							var msg = '';

							// update due date field
							$table_row.find('.task-template-due-field')
							.first()
							.data('DateTimePicker')
							.date(moment(response.due_date).format('YYYY-MM-DD'));

							// if date was invalid, show error message
							if (response.invalid && response.invalid === true) {
								msg = '<strong>Please Note:</strong> you are basing the due date on ';
								msg += response.column_name + ',<br>however the ';
								msg += response.entity_name + ' does not have a date entered for that field.';
								msg += '<br>The due date of this task will be set to the current date.';

								$table_row.find('.task-template-due-date-warning')
									.first()
									.html(msg)
									.removeClass('hidden');
							}
						});
					}
				});
			});

			$('.task-checkbox').on('click', function allCheckTasks(e) {
				var count    = $('.task-checkbox').length,
					selected = 0;

				$('.task-checkbox').each(function selectedTask(e) {
					if ($(this).prop('checked')) {
						selected++;
					}
				});

				if (count === selected) {
					$('.check-all').prop('checked', true);
				} else {
					$('.check-all').prop('checked', false);
				}
			});

			// trigger on page load
			$('#' + form_id + entity_type + '_id').trigger('change');
		}
	};
}(jQuery, window.Adzuki || {}));
